/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const video = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#video_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M15 8v-.7M5.667 1l-.934 3.733M11.267 1l-.934 3.733M6.5 14.067H1.933A.943.943 0 0 1 1 13.133V7.5m14-2.767H1v-2.8C1 1.425 1.425 1 1.933 1h12.134c.508 0 .933.425.933.933v2.8Zm-.226 6.99-3.76-2.255c-.296-.178-.707.046-.707.4v4.511c0 .354.411.578.707.4l3.76-2.255c.294-.177.287-.628 0-.8Z"
      />
    </g>
    <defs>
      <clipPath id="video_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default video
